import api from "./api";
import { Article } from "./article-model";

export type { Article };

export default function voteForArticle(
  articleId: string,
  direction: "up" | "down",
  value: number,
  customerId?: string,
  notify?: boolean
) {
  return api<Article>({
    method: "POST",
    path: `/helpcenter-public/article/${articleId}/vote`,
    body: { direction, value, customerId, notify },
  });
}
